module.exports = __webpack_public_path__ + "img/DO.9606d33d.png";